


























import { Component, Vue } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'
import ListTeams from '@/views/Company/Settings/Teams/List/ListTeams.vue'

@Component({
    components: {ListTeams},
})
export default class CompanySettingsTeamsList extends Vue {
    async navigateToCreate(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_teams_create',
        })
    }

    get sortedTeams(): Branch[] {
        return this.$currentCompany.branches
            .filter((team: Branch) => team instanceof Branch)
            .sort((a: Branch, b: Branch) => a.name.localeCompare(b.name)) as Branch[]
    }
}
